/**
 * HTTP status code 상수.
 *
 * ApiError.status 비교에서 매직넘버(401/403/...) 가 흩어지는 걸 막기 위한 단일 출처.
 * 새 코드 추가할 때 알파벳/카테고리 순으로 정렬 유지.
 */
export const HTTP_STATUS = {
  // 2xx
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,

  // 3xx (S3 PUT 성공 범위 체크 등에 사용)
  REDIRECT_MIN: 300,

  // 4xx
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,

  // 5xx
  INTERNAL_SERVER_ERROR: 500,
} as const;

export type HttpStatus = (typeof HTTP_STATUS)[keyof typeof HTTP_STATUS];
